import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  background: radial-gradient(circle, rgb(14, 33, 88), rgb(6, 13, 34));
  padding: 50px 0;
  display: flex;
`;

export const Top = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
`;

export const Actions = styled.div`
  position: absolute;
  bottom: 50px;
  right: 50px;
  flex-direction: row;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SmallCanvas = styled.div`
  width: 800px;
  min-width: 800px;
  height: calc(100vh - 200px);
  max-height: calc(100vh - 200px);
  display: flex;
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  height: 50px;
  margin: 0 auto;

  &.upload {
    margin: auto;
  }

  &.progress {
    flex-direction: column;
    align-items: center;
    margin: auto;
  }
`;

export const BannerAbsolute = styled.div`
  position: absolute;
`;

export const PromptDescription = styled.div`
  position: absolute;
  bottom: 50px;
  left: calc(50% + 90px);
  transform: translateX(-50%);
  width: 800px;
  flex: 1;
  text-align: center;
  font-size: 40px;
  color: #ffff66; /* yellowish */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.9), -2px -2px 4px rgba(0, 0, 0, 0.9); /* classic subtitle shadow */
  overflow: hidden;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
